import RateClassify from "./RateClassify";

export default RateClassify;
